<template>
  <div>
    <div v-if="contentPromotion" class="referral p-6 mb-7">
      <p v-dynamic-content="{ rawText: contentPromotion }"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Referral',
  computed: {
    content() {
      return this.$store.state.data.content
    },
    contentPromotion() {
      const { contentPromotion } = this.$store.state.data
      return contentPromotion && contentPromotion.content
    },
    locale() {
      return this.$store.getters.locale
    },
  },
  watch: {
    locale(val) {
      if (val) this.$store.dispatch('getContentPromotion')
    },
  },
  mounted() {
    this.$store.dispatch('getContentPromotion')
  },
}
</script>
